import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { KsefDocumentSendingError } from '@skylab-shared/dataModel';
import { MS_PER_MINUTE } from '@skylab-shared/utils';

export interface SaleSendDocumentsToKsefCommandParams {
    documents: { documentId: number; version: string; }[];
}

export type SaleSendDocumentsToKsefInitializeStatus = "Initialized" | "Error";

export type SaleSendDocumentsToKsefResponse = {
    code: KsefDocumentSendingError,
    documentId: number,
    initializeStatus: SaleSendDocumentsToKsefInitializeStatus,
    message: string
}[];

export class SaleSendDocumentsToKsefCommand extends Command<SaleSendDocumentsToKsefCommandParams, SaleSendDocumentsToKsefResponse> { }

export class SaleSendDocumentsToKsefCommandHandlerBase implements CommandHandler<SaleSendDocumentsToKsefCommand, SaleSendDocumentsToKsefCommandParams, SaleSendDocumentsToKsefResponse> {
    private static Url = TaggedUrl.join('eInvoices/sendToKsef', [Tags.Api]);

    public constructor(
        private readonly http: HttpService
    ) { }

    public async handleAsync({ params }: SaleSendDocumentsToKsefCommand): Promise<SaleSendDocumentsToKsefResponse> {
        const { data } = await this.http.post<SaleSendDocumentsToKsefResponse>(SaleSendDocumentsToKsefCommandHandlerBase.Url, params?.documents, { timeout: MS_PER_MINUTE });
        return data;
    }
}
